import { createBrowserRouter, RouterProvider } from 'react-router';
import { AppProvider } from './provider';
import { routes } from './router';

const router = createBrowserRouter(routes);

/**
 * Composition root: the provider stack around the data router.
 */
export function App() {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
}
